import {DocumentNode} from 'graphql';
import {gql} from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {ResultGraphQL} from '../../../../graphql-fragments/results/__generated/ResultGraphQL';

export type PendingTableRow = Pick<ResultGraphQL, 'id' | 'tagsJson'>;

export const FETCH_PENDING_TABLE_ROWS_QUERY: DocumentNode = gql`
  query FetchPendingTableRowsQuery($tableId: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    structuredTable(id: $tableId) {
      ... on StructuredTableNode {
        id
        pendingTableRows {
          ...ResultGraphQL
        }
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('Result').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
